import { render, staticRenderFns } from "./UiGrid.vue?vue&type=template&id=2808be98"
import script from "./UiGrid.vue?vue&type=script&lang=js"
export * from "./UiGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports